<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Prospect Students</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label>Session *</label>
          <select class="form-control" v-model="filter.SemesterID" v-on:change="loadOfferedPrograms()">
            <option value="">--Select Session--</option>
            <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label> Degree * </label>
          <select class="form-control" v-model="filter.DegreeID" v-on:change="loadOfferedPrograms()">
            <option value="">--Select Degree--</option>
            <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Program</label>

          <select class="form-control" v-model="filter.ProgramID">
            <option value="0">--Select Program--</option>
            <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Village/Town/City</label>
          <select class="form-control" v-model="filter.CityID">
            <option value="">--Select City--</option>
            <option v-for="item in city" v-bind:value="item.CityID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Category</label>

          <select class="form-control" v-model="filter.CategoryID">
            <option value="0">--Select Category--</option>
            <option v-for="item in category" v-bind:value="item.AdmissionCategoryID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Hostel Required</label>
          <select class="form-control" v-model="filter.Hostel">
            <option value="">--Select Type--</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Disability</label>

          <select class="form-control" v-model="filter.Disability">
            <option value="">--Select Type--</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Document</label>

          <select class="form-control" v-model="filter.Document">
            <option value="">--Select--</option>
            <option value="Verified">Verified</option>
            <option value="Un-Verified">Un-Verified</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>District</label>

          <input class="form-control" v-model="filter.District" />
        </div>
        <div class="col-md-4">
          <label>Payment</label>

          <select class="form-control" v-model="filter.Payment">
            <option value="">--Select--</option>
            <option value="Verified">Received</option>
            <option value="Un-Verified">Un-Received</option>
          </select>
        </div>
        <div class="col-md-12">
          <div class="form-group float-right">
            <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
            <!--<button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="exportexcel()" v-if="exceldatastatus==='enabled'">Export All Data</button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        departments: [],
        programs: [],
        selDegreeID: 0,
        semesters: [],
        degrees: [],
        filter: { SemesterID: '', ProgramID: 0, CityID: 0, CategoryID: 0, DegreeID: '',Hostel:'',Disability:'', Name: '', Payment: '', Document: '', District:'', ApplicationStatus: 0, DisplayPicture: false },
        prospects: [],
        Types: 0,
        exceldata: [],
        exceldatastatus: 'default',
        delete: { id: '', ind: '' },
        showImage: false,
        city: [],
        category: [],
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
    },

    methods: {

      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/ProgWiseprospectStudentsPageLoad')
          .then(function (pl) {
            endReq();
            vm.semesters = pl.data["sem"];
            vm.degrees = pl.data["deg"];
            vm.category = pl.data["category"];
            vm.city = pl.data["city"];
          })
      },

      loadOfferedPrograms: function () {
        if (this.filter.SemesterID && this.filter.DegreeID) {
          var vm = this;
          startReq();
          axios.post('/api/AdmissionApi/loadOfferedPrograms?semID=' + vm.filter.SemesterID + '&degID=' + vm.filter.DegreeID)
            .then(function (pl) {
              endReq();
              vm.programs = pl.data;
            })
        }
      },

      loadDepartment() {
        var vm = this;
        vm.prospects = [];

        startReq();
        axios.post('/api/AdmissionApi/loadDepartments?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID)
          .then(function (res) {
            vm.departments = res.data;
            endReq();
          })
      },

      loadPrograms() {
        var vm = this;
        vm.prospects = [];

        startReq();
        axios.post('/api/AdmissionApi/loadPrograms?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID + "_" + vm.filter.DepartmentID)
          .then(function (res) {
            vm.programs = res.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      cancel() {
        window.location.reload();
      },

      btnSearch() {

        startReq();

        var vm = this;
        if (vm.filter.SemesterID == 0) {
          toastr.error("Please select Session", "Error!");
          endReq();
        }
        else {

          axios.post('/api/AdmissionApi/ProgWiseProspectStudentsCount', {
            filter: vm.filter,
            type: 0,
          })
            .then(function (res) {
              window.open("/Admission/ProgWiseProspectStudentPrint", "_blank")
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            })
        }
      }
    }
  })
</script>

<style>
  table thead tr th {
    background-color: #605ca8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/progwiseprospectstudentsummary.vue